module.exports = __webpack_public_path__ + "img/streetsweeper_stopped.ee102c1d.svg";